import { DateRange } from 'react-day-picker'

import { MetricCardComparisonModel } from '@/types/clarity'
import { dateToString } from '@/utils'
import { getDateRange } from '@/utils/date'

export function formatMetric(
  metric: number | string | null | undefined,
  decimalPlaces: number = 0
): number {
  const numericValue =
    typeof metric === 'number' || typeof metric === 'string'
      ? Number(metric)
      : 0
  return Number(numericValue.toFixed(decimalPlaces))
}

// TODO: Check this one again and try to use it in the other hooks
export async function setLocalTrendingData(
  branches: string,
  formattedDate: string,
  mtdStorageKey: string,
  ytdStorageKey: string,
  setMetricCardData: (
    data: MetricCardComparisonModel<typeof setMetricCardData>
  ) => void,
  fetchMetrics: (
    branches: string,
    startDate: string,
    endDate: string
  ) => Promise<{
    branchMetrics: Parameters<typeof fetchMetrics>[2] extends {
      branchMetrics: infer U
    }
      ? U
      : never
    companyMetrics: Parameters<typeof fetchMetrics>[2] extends {
      companyMetrics: infer U
    }
      ? U
      : never
  }>
) {
  const mtdDate = getDateRange('month-to-date')
  const ytdDate = getDateRange('year-to-date')
  const mtdTrendingDate = mtdDate.trending as DateRange
  const ytdTrendingDate = ytdDate.trending as DateRange

  const { branchMetrics: mBranchMetrics, companyMetrics: mCompanyMetrics } =
    await fetchMetrics(
      branches,
      dateToString(mtdDate, 'from'),
      dateToString(mtdDate, 'to')
    )

  const { branchMetrics: mtdBranchMetrics, companyMetrics: mtdCompanyMetrics } =
    await fetchMetrics(
      branches,
      dateToString(mtdTrendingDate, 'from'),
      dateToString(mtdTrendingDate, 'to')
    )

  const { branchMetrics: yBranchMetrics, companyMetrics: yCompanyMetrics } =
    await fetchMetrics(
      branches,
      dateToString(ytdDate, 'from'),
      dateToString(ytdDate, 'to')
    )

  const { branchMetrics: ytdBranchMetrics, companyMetrics: ytdCompanyMetrics } =
    await fetchMetrics(
      branches,
      dateToString(ytdTrendingDate, 'from'),
      dateToString(ytdTrendingDate, 'to')
    )

  const mtdStorageValue = {
    date: formattedDate,
    branches: branches,
    branchMetrics: mBranchMetrics,
    companyMetrics: mCompanyMetrics,
    branchMetricsForTrending: mtdBranchMetrics,
    companyMetricsForTrending: mtdCompanyMetrics,
  }
  const ytdStorageValue = {
    date: formattedDate,
    branches: branches,
    branchMetrics: yBranchMetrics,
    companyMetrics: yCompanyMetrics,
    branchMetricsForTrending: ytdBranchMetrics,
    companyMetricsForTrending: ytdCompanyMetrics,
  }

  setMetricCardData({
    currMetricsMonthly: mtdStorageValue.companyMetrics,
    currMetricsYearly: ytdStorageValue.companyMetrics,
    prevMetricsMonthly: mtdStorageValue.companyMetricsForTrending,
    prevMetricsYearly: ytdStorageValue.companyMetricsForTrending,
  })

  localStorage.setItem(mtdStorageKey, JSON.stringify(mtdStorageValue))
  localStorage.setItem(ytdStorageKey, JSON.stringify(ytdStorageValue))
}
